import { configureStore } from "@reduxjs/toolkit";
import { myDataReducer, MyDataState } from "./myData";
import { paymentReducer, PaymentState } from "./payment";

export interface AppState {
    myData: MyDataState;
    payment: PaymentState;
}

export const store = configureStore({
    reducer: {
        myData: myDataReducer,
        payment: paymentReducer
    }
});
